import './setupSentry';
import './App.css';

import { ApolloProvider } from '@apollo/client';
import { CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import Cohere from 'cohere-js';
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { client } from './async/utils/client';
import { createStore } from './store';
import { muiTheme } from './theme';
import { Main } from './views/Main';

Cohere.init('fNvvLLSPyDsiWqfSDx3q8cIx');

const store = createStore();

const App: React.ComponentType = () => (
  <div className="App">
    <CssBaseline />
    <ReduxProvider store={store}>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <ThemeProvider theme={muiTheme}>
            <Main />
          </ThemeProvider>
        </BrowserRouter>
      </ApolloProvider>
    </ReduxProvider>
  </div>
);

export default App;
